import React from "react";
import Button from "components/common/Button";
import Show from "components/common/Show";
import cx from "classnames";

const View = ({
  content,
  hideButtonCancel = false,
  hideButtonAccept = false,
  cancelLabel = "",
  acceptLabel = "",
  cancelComponent,
  acceptComponent,
  cancelProps,
  acceptProps,
  onCancel,
  onAccept,
}: {
  content: React.ReactNode;
  hideButtonCancel?: boolean;
  hideButtonAccept?: boolean;
  onCancel?: () => void;
  onAccept?: () => void;
  cancelLabel?: string;
  acceptLabel?: string;
  cancelProps?: any;
  acceptProps?: any;
  [key: string]: any;
}) => {
  return (
    <div className="w-full h-full flex flex-col bg-white">
      <div className="my-4 text-center text-sm">
        <Show.When isTrue={!!content}>{content}</Show.When>
      </div>
      <div className="flex justify-center gap-3">
        <Show.When isTrue={!!cancelComponent && !hideButtonCancel}>
          {cancelComponent}
        </Show.When>
        <Show.When isTrue={!cancelComponent && !hideButtonCancel}>
          <Button
            className={cx("min-w-[120px] px-10")}
            label={<span className="font-semibold">{cancelLabel}</span>}
            light={true}
            variant={"gray"}
            {...cancelProps}
            onClick={onCancel}
          />
        </Show.When>
        <Show.When isTrue={!!acceptComponent && !hideButtonAccept}>
          {acceptComponent}
        </Show.When>
        <Show.When isTrue={!acceptComponent && !hideButtonAccept}>
          <Button
            className="min-w-[120px]"
            label={<span className="font-semibold">{acceptLabel}</span>}
            {...acceptProps}
            onClick={onAccept}
          />
        </Show.When>
      </div>
    </div>
  );
};

export default View;
